export default "__VITE_ASSET__B_T9fnAs__"